// extracted by mini-css-extract-plugin
export default {"btn":"cameralive_btn__CwZg-","back":"cameralive_back__CNre+"};